import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import CommonIcons from "@base/assets/icons";
import CommonStyles from "@components/CommonStyles";

interface IProps {
  open: boolean;
  title: string;
  description: string;
  detailLabel: string;
  onHome: () => void;
  onDetail: () => void;
}

/** Shown once the appointment exists; nothing behind it can be used, and it only closes through its buttons. */
export default function BookingSuccessModal({ open, title, description, detailLabel, onHome, onDetail }: IProps) {
  //! state
  const { t } = useTranslation();

  //! render
  return (
    <Modal open={open} centered closable={false} maskClosable={false} keyboard={false} footer={null} zIndex={2100}>
      <div className="flex flex-col items-center gap-4 text-center py-4">
        <CommonIcons.IconCheckCircle />
        <span className="text-common-maintext text-lg font-semibold font-['Inter']">{title}</span>
        <span className="text-common-subtext text-sm font-normal font-['Inter'] whitespace-pre-line">{description}</span>

        <div className="w-full grid grid-cols-2 gap-3 mt-2">
          <CommonStyles.ButtonUI
            className="h-12 bg-common-primary100 text-common-primary hover:!bg-common-primary200 hover:!text-common-primary"
            onClick={onHome}
          >
            {t("booking.home")}
          </CommonStyles.ButtonUI>
          <CommonStyles.ButtonUI className="h-12" onClick={onDetail}>
            {detailLabel}
          </CommonStyles.ButtonUI>
        </div>
      </div>
    </Modal>
  );
}
